// FOUNDER RULING 2026-09-26 — THERE IS NO SECOND CHECKOUT PAGE. The same-site Kit export flow at
// `/mountain-<code>/booking/review` is the only place a card is entered, reviewed and confirmed. This file
// replaces `checkout-zone.ts`, which proxied `/checkout/*` to the separate checkout service and handed the
// customer to it; nothing in root claims, proxies or links to that address any more (next.config.ts
// `redirects()` sends an old `/checkout…` URL to the `/cart` hand-off, which forwards to the review page).
//
// No "use client" and no `@/libs/Env`: it is imported by client code and by unit tests.

/**
 * Where Stripe returns a customer whose payment method needed a full-page redirect (cards authenticate in
 * Stripe's own modal and never reach this): the funnel's review page for the basket's mountain, carrying the
 * order as `sg_order`. InpageCardPayment then reads the SERVER's status for it. `redirect_status`, which
 * Stripe appends, is a client-side result and never names an outcome on its own.
 */
export function checkoutReturnUrl(origin: string, mountainCode: string, orderDocumentId: string): string {
  const code = /^[a-z0-9-]+$/.test(mountainCode) ? mountainCode : "whistler";
  return `${origin.replace(/\/$/, "")}/mountain-${code}/booking/review?sg_order=${encodeURIComponent(orderDocumentId)}`;
}
